import React, { FC } from 'react';

import { IPromotionalCode } from '../../types';
import PromoCodeItem from '../PromoCodeItem/PromoCodeItem';

type DiscountsListProps = {
  promoCodes: IPromotionalCode[];
};

const PromoCodeList: FC<DiscountsListProps> = ({ promoCodes }) => {
  return (
    <div className={'flex flex-col flex-1 gap-4'}>
      {promoCodes.map((promoCode) => (
        <PromoCodeItem key={promoCode.code} {...promoCode} />
      ))}
    </div>
  );
};

export default React.memo(PromoCodeList);
